import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ChatMessage = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M5.49598 17.57C6.11765 17.197 6.82899 17 7.55397 17H20V6L4 6V18.4676L5.49598 17.57L6.52498 19.285L5.02899 20.1826C3.69594 20.9824 2 20.0222 2 18.4676V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V17C22 18.1046 21.1046 19 20 19H7.55397C7.19148 19 6.83581 19.0985 6.52498 19.285L5.49598 17.57Z"
      fill="currentColor"
    />
    <path d="M11 12.5V7.5H13V12.5H11Z" fill="currentColor" />
    <path d="M11 13.5V15.5H13V13.5H11Z" fill="currentColor" />
  </Icon>
));

export default ChatMessage;
